/*
 * BuroEcl
 * Copyright (c) 2023 Buroclic. All rights reserved.
 * 
 * This file corresponds to the display of the 'Powered by BuroClic' image
 * mainly used in authentication-relative form or sidebars
 */

// Imports
import React from 'react';
import PropTypes from "prop-types";


export const PoweredByBc = (props) => {
    // JSX Template
    return (
        <div className={`text-gray-500 italic font-semibold text-center ${props.className ? props.className : ''}`}>
            <a href='https://buroclic.com/' target='__blank' className='h-full w-full block'>
                <img className={`block ${props.imgClassName ? props.imgClassName : 'h-full w-auto m-auto'}`} src='/images/poweredByBc.png' alt='Powered by BuroClic'/>
            </a>
        </div>
    );
};

PoweredByBc.propTypes = {
    className: PropTypes.string,
    imgClassName: PropTypes.string
}